import Spec from "csi/core/Spec";
import { Context } from "csi/def/Context";
import PathMatrix from "csi/table/matrix/Path";
import { pathCreate } from "csi/utility/pathUtility";
import declare from "dojo/_base/declare";
import { C8Node } from "src/c8-platform/type/node";
import { ThemeStyles } from "./ThemeStyles";

const ThemeColorwayMatrix = declare(PathMatrix, {
	bAllowColumnFilter: true,
	columnPath: pathCreate("ColorColorways"),
	hideLoneSubheader: true,
	restrictQuery: true,

	/**
	 * @override
	 * Match Style Colorway with column by comparing ColorSpecification attribute
	 */
	_filterNodes({ cache }: Context, { columnUrl }: Spec, nodes: C8Node[]): C8Node[] {
		const themeColor = cache.get(columnUrl);
		const colorSpecification = themeColor.Actual;
		return nodes.filter((node) => node.ColorSpecification === colorSpecification);
	},

	/**
	 * @override
	 * If size matrix is displayed, then add extra nodes to render information per size
	 */
	_getSpecNodes(ctx: Context, spec: Spec, nodes: C8Node[]): C8Node[] {
		const { cache, queryResult, view } = ctx;
		const { extendedPath, id } = spec.key;
		const style = ctx.getRowNode();
		const themeView = view as ThemeStyles;
		const { sizeMatrixSpec } = themeView;
		const sizes = sizeMatrixSpec ? cache.getNodes(style.ProductSizes) : [];
		const displayedSizes = themeView.applyMatrixAdHocFilters(queryResult, sizeMatrixSpec, sizes);
		const n = displayedSizes.length;
		const isColorwayActive = (id === "Active") && (extendedPath.endType === "Colorway");

		ctx.setParam(themeView.PARAM_COLORWAY_URL, nodes[0]?.$URL);

		if (!isColorwayActive) {
			return nodes;
		}

		if (!view.isPreview && ctx.isStaticOutput()) {
			// when output is static (print, excel, ...), then output X per size if any; otherwise single X for Colorway if it exists and is active
			return n ? displayedSizes : nodes;
		}

		// if a Colorway does not exist for the theme color and rendering Colorway.Active, then pass parent Style as the node - a tooltip action will be available to create the colorway
		if (!nodes.length) {
			nodes = [style];
		}

		// add each size as a node in the matrix too to display if a Colorway exists for this size (size could be inactive)
		return nodes.concat(displayedSizes);
	},
});

export = ThemeColorwayMatrix;